"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_validator_1 = require("./base-validator");

var Validator =
/** @class */
function () {
  function Validator() {
    this.vatAddressName = new base_validator_1.BaseEntityFieldValidator(0, 100, base_validator_1.BaseEntityFieldValidator.genericTextInputRegexPattern);
    this.vatAddressDetail = new base_validator_1.BaseEntityFieldValidator(0, 150, base_validator_1.BaseEntityFieldValidator.genericTextInputRegexPattern);
    this.vatAddressDetailWithComma = new base_validator_1.BaseEntityFieldValidator(0, 150, /^[\u0E00-\u0E3E\u0E40-\u0E7Fa-zA-Z0-9\u2018\u2019\u201C\u201D\u00AE\u002F\u002c\&\(\)\_\+\-\*\'\"\#\@\%\.\<\>\|\s]*$/);
    this.vatBranchNoFiveDigitOnly = new base_validator_1.BaseEntityFieldValidator(5, 5, /^[0-9]{5}$/);
    this.vatBranchNoFiveZero = new base_validator_1.BaseEntityFieldValidator(5, 5, /^(?!0{5})/);
    this.vatAddressTaxId = new base_validator_1.BaseEntityFieldValidator(13, 13, /^\d{13}$/);
    this.vatAddressPostalCode = new base_validator_1.BaseEntityFieldValidator(5, 5, /^[0-9]*$/);
  }

  return Validator;
}();

exports.VatValidator = new Validator();